<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Blog Right Sidebar" />
            <BlogRightSidebar />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import BlogRightSidebar from '../BlogRightSidebar/BlogRightSidebar'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'BlogRightSidebarPage',
    components: {
        NavBar,
        PageTitle,
        BlogRightSidebar,
        FooterComp,
    }
}
</script>